import QRHandler from './QRHandler'

export default QRHandler


// WEBPACK FOOTER //
// ./src/components/home/qrHandler/index.jsx